// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cfV_","content":"styles_content__2YrWW","tableWrap":"styles_tableWrap__3MoFZ"};